
class GoogleMapPopup {
	isOpen = false;

	constructor( canvasEl, infoWindow ) {
		this.canvasEl = canvasEl;
		this.infoWindow = infoWindow;

		this.popupContainerEl = this.canvasEl.closest( '.mdl_embed' )?.querySelector( '.mdl_embed__popup_container' );

		// If we do not find a container, we go with the default method.
		if ( this.popupContainerEl ) {
			this.infoWindow.addListener( 'visible', () => this.onOpenPopup() );
			this.infoWindow.addListener( 'closeclick', () => this.onClosePopup() );

			// Click on the close button.
			this.popupContainerEl.addEventListener( 'click', ( ev ) => {
				if ( ev.target.closest( '.close_button' ) ) {
					this.onClosePopup();
				}
			} );

			// Watch for changes of Breakpoint.
			this.getMedia().watch( ( ev ) => this.onBreakpointChange( ev ), 'desktop' );
		}
	}

	getMedia() {
		return window.EN.Media;
	}

	onOpenPopup() {
		const infoWindow = this.infoWindow;

		this.lastAnchor = ( infoWindow.getAnchor() || this.lastAnchor );
		this.lastMap = ( infoWindow.getMap() || this.lastMap );
		if ( ! this.getMedia().matches( 'desktop' ) ) {
			this.infoWindow.close();
		}

		this.popupContainerEl.innerHTML = ( infoWindow.getHeaderContent() || '' ) + ( infoWindow.getContent() || '' );
		this.isOpen = true;
	}

	onClosePopup() {
		this.isOpen = false;
		this.popupContainerEl.innerHTML = '';
		this.infoWindow.close();
	}

	onBreakpointChange() {
		// Nothing open, nothing to do.
		if ( ! this.isOpen ) {
			return;
		}

		// Open the window.
		this.infoWindow.open( this.lastMap, this.lastAnchor );
	}
}

document.addEventListener( 'map_initialized.koe', ( ev ) => {
	const MapWrapper = ev.detail;

	const canvasEl = MapWrapper.canvasEl;
	const infoWindow = MapWrapper.infoWindow;

	canvasEl.KOE_GOOGLE_MAP_POPUP ??= new GoogleMapPopup( canvasEl, infoWindow );
} );
